import { clx } from "~/design-system"
import Spinner from "./spinner"

type Props = {
  uiBackground?: boolean
}

const FullscreenLoading = ({ uiBackground }: Props) => (
  <div
    className={clx(
      "flex h-screen w-full items-center justify-center",
      { "bg-grey-10": uiBackground }
    )}
  >
    <Spinner variant="secondary" />
  </div>
)

export default FullscreenLoading